import React, { useState } from 'react';

export default function CommentForm({
  onSubmit,
  onCancel,
  submitting,
  placeholder = "Add a comment...",
  user,
  isReply = false
}) {
  const [content, setContent] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim() || submitting) return;

    await onSubmit(content.trim());
    setContent('');
  };

  const handleCancel = () => {
    setContent('');
    if (onCancel) onCancel();
  };

  if (!user) return null;

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <div className="flex gap-2">
        {/* User avatar */}
        <div className="flex-shrink-0">
          <div className={`bg-gradient-to-br from-indigo-400 to-indigo-600 rounded-full flex items-center justify-center text-white font-medium ${isReply ? 'w-6 h-6 text-xs' : 'w-8 h-8 text-sm'}`}>
            {user.username ? user.username.charAt(0).toUpperCase() : 'U'}
          </div>
        </div>

        <div className="flex-grow">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder={placeholder}
            disabled={submitting}
            maxLength={280}
            className={`
              w-full border border-gray-200 rounded-lg px-3 py-2
              resize-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent
              disabled:opacity-50 disabled:cursor-not-allowed
              text-gray-900 placeholder-gray-500 bg-white
              ${isReply ? 'text-sm' : 'text-sm'}
            `}
            rows={isReply ? 2 : 3}
            style={{ minHeight: isReply ? '60px' : '72px' }}
          />

          {/* Character count */}
          <div className="flex justify-between items-center mt-1">
            <span className={`text-xs ${content.length > 250 ? 'text-red-500' : 'text-gray-400'}`}>
              {content.length}/280
            </span>
          </div>
        </div>
      </div>

      {/* Action buttons */}
      <div className="flex justify-end gap-2 pl-10">
        {onCancel && (
          <button
            type="button"
            onClick={handleCancel}
            disabled={submitting}
            className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 disabled:opacity-50"
          >
            Cancel
          </button>
        )}
        <button
          type="submit"
          disabled={!content.trim() || submitting}
          className="
            px-4 py-1 bg-indigo-600 text-white text-sm rounded-md
            hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed
            transition-colors duration-200
          "
        >
          {submitting ? 'Posting...' : 'Post'}
        </button>
      </div>
    </form>
  );
}